module.exports = __webpack_public_path__ + "static/img_9715-b29f9a0e856c55568807bf9e7631d6a0.webp";